import { AssortmentItemMinimal } from '@retail/my-assortment/types';
import { useAssortmentTagActions } from '@retail/my-assortment/context';
import EditAssortmentTagsDialog from './EditAssortmentTagsDialog';

interface Props {
  selectedItems: AssortmentItemMinimal[];
  assortmentId: number;
  resetCheckedItems: () => void;
  onClose: () => void;
}

export function EditAssortmentTagsDialogContainer({
  selectedItems,
  assortmentId,
  resetCheckedItems,
  onClose,
}: Props) {
  const { updateAssortmentTags, updateAssortmentTagsIsLoading } = useAssortmentTagActions();

  return (
    <EditAssortmentTagsDialog
      open
      selectedItems={selectedItems}
      assortmentId={assortmentId}
      isSaving={updateAssortmentTagsIsLoading}
      updateAssortmentTags={updateAssortmentTags}
      resetCheckedItems={resetCheckedItems}
      onClose={onClose}
    />
  );
}
